import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts';

const TrendsCharts = ({ data, settings }) => {
  if (!data || !data.weeklyLoad) return null;

  const { weeklyLoad, acwr, tsb, chronicLoad, acuteLoad } = data;

  // Prepare data for chart
  // weeklyLoad is typicaly [ { week: '...', distance: ... }, ... ]
  // We might need to adapt based on actual data structure from worker.
  const chartData = weeklyLoad.map(item => ({
      name: item.weekLabel || item.date || 'Week',
      distance: parseFloat(item.distance || 0),
      longRun: parseFloat(item.longRunDistance || 0),
      target: parseFloat(settings?.weeklyTarget || 40) // simplistic target line
  }));

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 col-span-1 md:col-span-2 lg:col-span-3">
        <div className="flex justify-between items-center mb-6">
            <h3 className="text-gray-400 text-xs uppercase tracking-wider">Load Trends (5 Weeks)</h3>
            <div className="flex gap-4 text-xs">
                <div className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-blue-500"></span> Volume</div>
                <div className="flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-gray-600"></span> Target</div>
            </div>
        </div>
        
        <div className="h-64 w-full">
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={chartData}>
                    <defs>
                        <linearGradient id="colorDistance" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.3}/>
                            <stop offset="95%" stopColor="#3B82F6" stopOpacity={0}/>
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="#374151" vertical={false} />
                    <XAxis 
                        dataKey="name" 
                        stroke="#9CA3AF" 
                        fontSize={12} 
                        tickLine={false}
                        axisLine={false}
                    />
                    <YAxis 
                        stroke="#9CA3AF" 
                        fontSize={12} 
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={(val) => `${val}km`}
                    />
                    <Tooltip 
                        contentStyle={{ backgroundColor: '#1F2937', borderColor: '#374151', color: '#F3F4F6' }}
                        itemStyle={{ color: '#F3F4F6' }}
                    />
                    <Area 
                        type="monotone" 
                        dataKey="distance" 
                        stroke="#3B82F6" 
                        fillOpacity={1} 
                        fill="url(#colorDistance)" 
                        strokeWidth={3}
                    />
                     {/* We could add target line reference line */}
                </AreaChart>
            </ResponsiveContainer>
        </div>
        
        {/* Additional Stats Footer */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6 pt-4 border-t border-gray-700 text-center">
             <div>
                 <p className="text-xs text-gray-500">Chronic Load (CTL)</p>
                 <p className="text-lg font-bold text-white">{chronicLoad || 0}</p>
             </div>
             <div>
                 <p className="text-xs text-gray-500">Acute Load (ATL)</p>
                 <p className="text-lg font-bold text-white">{acuteLoad || 0}</p>
             </div>
             <div>
                 <p className="text-xs text-gray-500">Form (TSB)</p>
                 <p className={`text-lg font-bold ${tsb > 0 ? 'text-green-400' : 'text-yellow-400'}`}>
                     {tsb || 0}
                 </p>
             </div>
             <div>
                 <p className="text-xs text-gray-500">ACWR</p>
                 <p className="text-lg font-bold text-blue-400">{acwr || '-'}</p>
             </div>
        </div>
    </div>
  );
};

export default TrendsCharts;
